import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {StorageTransferListItemDto, StorageTransferStatusDto} from "../../api/sts";

class StsOverviewStore {
    get status(): StorageTransferStatusDto[] | undefined {
        return this._status;
    }

    set status(value: StorageTransferStatusDto[] | undefined) {
        this._status = value;
    }
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }
    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }
    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }
    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }
    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }
    get query(): string | undefined {
        return this._query;
    }

    set query(value: string | undefined) {
        this._query = value;
    }
    set size(value: number) {
        this._size = value;
    }
    get size(): number {
        return this._size;
    }
    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }
    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }
    get items(): StorageTransferListItemDto[] {
        return this._items;
    }

    private set items(value: StorageTransferListItemDto[]) {
        this._items = value;
    }

    private _items: StorageTransferListItemDto[] = []

    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25
    private _query: string | undefined
    private _fromRelative: string | undefined
    private _toRelative: string | undefined
    private _fromAbsolute: string | undefined
    private _toAbsolute: string | undefined
    private _customerId: string | undefined
    private _status: StorageTransferStatusDto[] | undefined
    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const {
            page,
            size,
            query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status
        } = this

        const response = await catchApi(async () => api.sts.api.getStorageTransferList({
            page: page - 1,
            size,
            q: query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status
        }))

        const responseData = response?.data
        this.pages = responseData?.totalPages || 0
        this.items = (responseData?.items || [])
    }
}

const stsOverviewStore = new StsOverviewStore()

export {
    stsOverviewStore
}
